const credentials = {
  'credentials_填写认证资料': { cn: '填写认证资料', en: 'Fill in file', kr: '' },
  'credentials_重新认证': { cn: '重新认证', en: 'Recertification', kr: '' },
  'credentials_使用平台前请完成企业认证流程': { cn: '使用前请先完成资质认证', en: 'Please complete the enterprise certification process before using the platform' },
  'credentials_创建第三方应用前请先完成资质认证': { cn: '创建第三方应用前请先完成资质认证', en: 'Please complete qualification certification before creating third-party applications' },
  'credentials_使用平台前请完成企业信息认证流程': { cn: '使用前请先完成资质认证', en: 'Please complete the enterprise information certification process before using the platform' },
  'credentials_进入认证界面': { cn: '进入认证界面', en: 'Enter the authentication interface' },
  'credentials_企业认证': { cn: '企业认证', en: 'Enterprise Certification' },
  'credentials_个人认证': { cn: '个人认证', en: 'Personal authentication' },
  'credentials_资质认证': { cn: '资质认证', en: 'Qualification certification' },

  'credentials_请选择认证方式': { cn: '请选择认证方式', en: 'Select an authentication mode' },
  'credentials_认证方式': { cn: '认证方式', en: 'authentication' },

  'credentials_提交时间': { cn: '提交时间', en: 'Submission time' },
  'credentials_企业': { cn: '企业', en: 'Company' },
  'credentials_个人': { cn: '个人', en: 'Personal' },

  'credentials_待审核': { cn: '待审核', en: 'To be checked' },
  'credentials_已通过': { cn: '已通过', en: 'Adopted' },
  'credentials_已打回': { cn: '已打回', en: 'Repulse' },
  'credentials_审核中': { cn: '审核中', en: 'Checking' },
  'credentials_审核通过': { cn: '审核通过', en: 'Adopted' },
  'credentials_证件类别': { cn: '证件类别：', en: 'Certificate type:' },
  'credentials_若认证资料审核不通过或有变更时，请点击': {
    cn: '若认证资料审核不通过或有变更时，请点击',
    en: 'If the information is not adopted or changed, click '
  },
  'credentials_重新提交': {
    cn: '重新提交',
    en: 'and submit again'
  },
  'credentials_后自动跳转': {
    cn: '后自动跳转',
    en: 'later automatically switches'
  },
  'credentials_请等待图片上传完毕': { cn: '请等待图片上传完毕', en: 'Please wait for uploaded pictures' },
  'credentials_企业全称': { cn: '企业全称：', en: 'Enterprise name:' },
  'credentials_员工规模': { cn: '员工规模：', en: 'Employee size:' },
  'credentials_税务登记证': { cn: '税务登记证', en: 'Tax registration certificate' },
  'credentials_营业执照': { cn: '营业执照', en: 'Business license' },
  'credentials_证件号码': { cn: '证件号码：', en: 'Certificate number:' },
  'credentials_注册资本': { cn: '注册资本：', en: 'Registered capital:' },
  'credentials_填写注册资本': { cn: '请填写注册资本（单位元）', en: 'Please fill in the registered capital (unit yuan)' },
  'credentials_有效期': { cn: '有效期：', en: 'Expiry date:' },
  'credentials_永续': { cn: '永续', en: 'Sustainable' },
  'credentials_请填写详细地址': { cn: '请填写详细地址', en: 'Fill in the address in detail' },
  'credentials_企业证件附件': { cn: '企业证件附件：', en: 'Enterprise certificate attachment:' },
  'credentials_最多可上传四张图片': { cn: '最多可上传四张图片，至少上传1张；支持.jpg .jpeg .bmp .png格式图片，大小不超过2M。', en: 'You can upload up to 4 pictures and at least 1 picture. JPG. JPEG. BMP. PNG image format is supported, the size is not more than 2M.' },
  'credentials_企业证件地址': { cn: '企业证件地址：', en: 'Address:' },
  'credentials_法人/负责人名称': { cn: '法人/负责人名称：', en: 'Contacts:' },
  'credentials_法人/负责人证件号码': { cn: '法人/负责人证件号码：', en: 'Identification Number:' },
  'credentials_身份证号码': { cn: '身份证号码', en: 'ID Number' },

  'credentials_法人/负责人证件附件': { cn: '法人/负责人证件附件：', en: 'Document attachment:' },
  'credentials_身份证照片': { cn: '身份证照片', en: 'ID Photo' },

  'credentials_法人/负责人证件类型': { cn: '法人/负责人证件类型：', en: 'Type of certificate:' },
  'credentials_请输入证件号码': { cn: '请输入证件号码', en: 'Enter ID number' },
  'credentials_请输入注册资本': { cn: '请输入注册资本', en: 'Enter registered capital' },
  'credentials_请输入有效期': { cn: '请输入有效期', en: 'Enter the expiry date' },
  'credentials_请上传企业证件附件': { cn: '请上传企业证件附件', en: 'Upload the attachment of enterprise certificate' },
  'credentials_请与证件名称保持一致': { cn: '请与证件名称保持一致', en: 'Keep the same name with the certificate' },
  'credentials_请填写证件号码': { cn: '请填写证件号码', en: 'Fill in the ID number' },
  'credentials_请上传身份证照片': { cn: '请上传身份证照片', en: 'Please upload ID photo' },

  'credentials_请上传法人/负责人名称': { cn: '请上传法人/负责人名称', en: 'Please upload the name of legal person/person in charge' },
  'credentials_请上传法人/负责人证件号码': { cn: '请上传法人/负责人证件号码', en: 'Please upload the legal person/person in charge ID number' },
  'credentials_请上传法人/负责人证件附件': { cn: '请上传法人/负责人证件附件', en: 'Please upload attachment, head of the legal person/documentation' },
  'credentials_请填写企业证件详细地址': { cn: '请填写企业证件详细地址', en: 'Please fill in business documents detailed address' },
  'credentials_身份证': { cn: '身份证', en: 'Id card' },
  'credentials_护照': { cn: '护照', en: 'Passport' },
  'credentials_请选择省': { cn: '请选择省', en: 'Select province' },
  'credentials_请选择市': { cn: '请选择市', en: 'Select city' },
  'credentials_请选择区': { cn: '请选择区', en: 'Select zone' },
  'credentials_请选择员工规模': { cn: '请选择员工规模', en: 'Select the size of employee' },
  'credentials_请上传本人手持身份证正反面照片；支持.jpg .jpeg .bmp .png格式照片，大小不超过2M': { cn: '请上传本人手持身份证正反面照片；支持.jpg .jpeg .bmp .png格式照片，大小不超过2M', en: 'Upload the front and back of ID card; Jpg. JPEG. BMP. PNG format, no more than 2M in size' },
  'credentials_50人以下': { cn: '50人以下', en: 'Less than 50 persons' },
  'credentials_50-149人': { cn: '50-149人', en: '50-149' },
  'credentials_150-499人': { cn: '150-499人', en: '150-499' },
  'credentials_1000-2999人': { cn: '1000-2999人', en: '1000-2999' },
  'credentials_3000人以上': { cn: '3000人以上', en: 'More than 3000 persons' },
  'credentials_系统将会尽快审核您的资料': { cn: '系统将会尽快审核您的资料（1-2个工作日），您可以在资质管理中查看认证情况', en: 'The system checks the data as quickly as possible (1-2 working days), one can view the certification state in the qualification administration' },
  'credentials_资质管理': { cn: '资质管理', en: 'Qualification management' },
  'credentials_资质管理按钮': { cn: '资质管理', en: 'talent management' },
  'credentials_您的认证资料由于': {
    cn: '您的认证资料由于{Desc}已打回，在您重新提交认证申请前，工作台功能不可用您已经创建的应用服务不受影响',
    en: 'Your certification information is repulsed due to{Desc}. Before you rE-submit the authentication application, the workbench function will not be available. The application services you have created will not be affected'
  },
  'credentials_非常抱歉，您无权访问该页面': { cn: '您的账号无权访问当前页面', en: 'You have no permission to visit this page' },
  'credentials_非常抱歉，您可以联系企业管理员为您开通权限': { cn: '您可以联系企业管理员为您开通权限', en: 'You can contact the enterprise administrator' },
  'credentials_请选择法人/负责人证件地址区域': { cn: '请选择法人/负责人证件地址区域', en: 'Select address area in ID of  the legal person/director' },
  'credentials_请选择法人/负责人证件地址城市': { cn: '请选择法人/负责人证件地址城市', en: 'Select address city in ID of the legal person / director' },
  'credentials_请选择法人/负责人证件地址省份': { cn: '请选择法人/负责人证件地址省份', en: 'Select certificate address of the legal person / director' },
  'credentials_请选择企业证件地址区域': { cn: '请选择企业证件地址区域', en: 'Select address area of the enterprise certificate' },
  'credentials_请选择企业证件地址城市': { cn: '请选择企业证件地址城市', en: 'Select the city in the address of the enterprise certificate' },
  'credentials_请选择企业证件地址省份': { cn: '请选择企业证件地址省份', en: 'Select the address of the enterprise certificate' },
  'credentials_法人/负责人证件地址': { cn: '法人/负责人证件地址:', en: 'Document address:' },
  'credentials_请输入企业全称': { cn: '请输入企业全称', en: 'Enter the full name of the enterprise' },
  'credentials_企业名称不支持数字，请勿填写数字': { cn: '企业名称不支持数字，请勿填写数字', en: 'The company name does not support numbers, please do not fill in numbers' },
  'credentials_企业名称前后不能包含空格': { cn: '企业名称前后不能包含空格', en: 'The enterprise name cannot contain Spaces before or after it' },

  'credentials_姓名不支持数字，请勿填写数字': { cn: '姓名不支持数字，请勿填写数字', en: 'The name cannot contain numbers. Do not fill in numbers' },
  'credentials_姓名前后不能包含空格': { cn: '姓名前后不能包含空格', en: 'The name cannot contain Spaces before or after it' },

  'credentials_文件大于2MB哦': { cn: '文件大于2MB哦', en: 'Files larger than 2 MB' },
  'credentials_请上传JPG、png、bmp、jpg文件': { cn: '请上传JPG、png、bmp、jpg文件', en: 'Please upload JPG, PNG, BMP, JPG files' },
  'credentials_请填写法人/负责人证件号码': { cn: '请填写法人/负责人证件号码', en: 'Fill in the ID number of the legal person / director' },
  'credentials_提交审核': { cn: '提交审核', en: 'Submit for checking' },
  'credentials_返回': { cn: '返回', en: 'Return' },
  'credentials_请填写法人/负责人证件详细地址': { cn: '请填写法人/负责人证件详细地址', en: 'Fill in the address of the legal person / director' }
}

export default {
  ...credentials
}
